///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { differenceInMonths, parseISO } from "date-fns";

import { strategyDurationOptions } from "./types";

export const getStrategyDuration = (
  strategicStartDateUTC,
  strategicEndDateUTC
) => {
  if (strategicStartDateUTC && strategicEndDateUTC) {
    let months = differenceInMonths(
      parseISO(strategicEndDateUTC),
      parseISO(strategicStartDateUTC)
    );

    return months > 0
      ? strategyDurationOptions.find(x => x.months === months)
      : null;
  } else return null;
};

export default getStrategyDuration;
